var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$auth.isAuthenticated)?_c('Navbar'):_vm._e(),_c('v-main',{staticClass:"body-biobank"},[_c('router-view'),(_vm.$loader.isLoading)?_c('Loading'):_vm._e()],1),_c('notifications',{attrs:{"group":"foo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }